import React from "react";
import AccountCardWrapper from "assets/scripts/components/presentational/AccountCardWrapper/AccountCardWrapper";
import styles from "./LoginNotice.module.less";
import useLocale from "assets/scripts/hooks/useLocale";
import isEmpty from "assets/scripts/utils/isEmpty";
function getNotice(locale) {
    if (locale === "es" && !isEmpty(window.DCM_SETTINGS.LOGIN_NOTICE_ES)) {
        return window.DCM_SETTINGS.LOGIN_NOTICE_ES;
    }
    if (!isEmpty(window.DCM_SETTINGS.LOGIN_NOTICE)) {
        return window.DCM_SETTINGS.LOGIN_NOTICE;
    }
    return null;
}
export default function LoginNotice() {
    const locale = useLocale();
    const notice = getNotice(locale);
    if (notice == null) {
        return null;
    }
    return (<div className="wrapper" role="alert">
			<AccountCardWrapper className={styles.card}>
				<i className="fa fa-exclamation-triangle" aria-hidden/>
				<span className="sr-only"> Notice </span>
				<div dangerouslySetInnerHTML={{ __html: notice }}/>
			</AccountCardWrapper>
		</div>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Login/LoginNotice/LoginNotice.tsx